export default "__VITE_ASSET__CcNEEjiB__"